import { Components, lighten, Theme, ThemeOptions } from "@mui/material/styles";
import { DefaultSpeciesThemes } from "./DefaultSpeciesThemeOptions";

import { Species } from "../../api/dtos/dtos";
import { MuiDropdownComponent } from "../../components/common/Dropdown";
import { grey } from "@mui/material/colors";

export const getDefaultAdminThemeOptions: (mode:  'light' | 'dark') => ThemeOptions = (mode) => ({
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 992,
            lg: 1250,
            xl: 1536,
        }
    },
    ...(mode === 'light') ? {
        typography: {
            fontFamily: 'Montserrat, sans-serif',
            h1: {
                fontSize: '2.5rem'
            },
            h2: {
                fontSize: '2.0rem',
                fontWeight: '400',
            },
            h3: {
                fontSize: '1.3rem',
                fontWeight: '500'
            },
            h4: {
                fontSize: '1.25rem',
            },
            h5: {
                fontSize: '1.2rem',
            },
            h6: {
                fontSize: '1.1rem',
            },
            body1: {
                fontSize: '1.0rem',
                fontWeight: '400'
            },
            body2: {
                fontSize: '0.9rem',
            }
        },
        palette: {
            mode: 'light',
            primary: {
                main: DefaultSpeciesThemes[Species.WildDog].primaryColor
            },
            secondary: {
                main: DefaultSpeciesThemes[Species.WildDog].secondaryColor
            },
            text: {
                primary: "#111",
                secondary: "#111"
            },
            background: {
                default: grey[300]
            }
        },
        components: {
            MuiDropdown: {
                styleOverrides: {
                    root: {
                        backgroundColor: lighten('#252423ff', 0.25),

                        '& .MuiMenuItem-root': {
                                color: '#ccc',
                            },
                        
                        '& .MuiMenuItem-root:hover': {
                            color: DefaultSpeciesThemes[Species.WildDog].primaryColor
                        }
                    }
                }
            },
            MuiBreadcrumbs: {
                styleOverrides: {
                    li: {
                        //color: lighten('#111', 0.9)
                    },
                    root: {
                        marginTop: '8px'
                    }
                }
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        
                    }
                }
            },
            MuiMenu: {
                styleOverrides: {
                    paper: {
                        backgroundColor: '#fff'
                    }
                }
            }
        }
    } : {
        typography: {
            fontFamily: 'Montserrat, sans-serif',
            h1: {
                fontSize: '2.5rem',
                color: '#eee'
            },
            h2: {
                fontSize: '2.0rem',
                fontWeight: '400',
                color: '#eee'
            },
            h3: {
                fontSize: '1.3rem',
                fontWeight: '500',
                color: '#eee'
            },
            h4: {
                fontSize: '1.25rem',
                color: '#eee'
            },
            h5: {
                fontSize: '1.2rem',
                color: '#eee'
            },
            h6: {
                fontSize: '1.1rem',
                color: '#eee'
            },
            body1: {
                fontSize: '1.0rem',
                fontWeight: '400'
            },
            body2: {
                fontSize: '0.9rem',
            }
        },
        palette: {
            mode: 'dark',
            primary: {
                main: DefaultSpeciesThemes[Species.WildDog].primaryColor
            },
            secondary: {
                main: DefaultSpeciesThemes[Species.WildDog].secondaryColor
            },
            text: {
                primary: "#fff",
                secondary: "#fff"
            },
            background: {
                default: '#252423ff'
            }
        },
        components: {
            MuiDropdown: {
                styleOverrides: {
                    root: {
                        backgroundColor: lighten('#252423ff', 0.25),

                        '& .MuiMenuItem-root': {
                                color: '#ccc',
                            },
                        
                        '& .MuiMenuItem-root:hover': {
                            color: DefaultSpeciesThemes[Species.WildDog].primaryColor
                        }
                    }
                }
            },
            MuiAutocomplete: {
                styleOverrides: {
                    paper: {
                        backgroundColor: lighten('#252423ff', 0.25),
                    },

                    listbox: {
                        '& .MuiAutocomplete-option': {
                            color: 'white',
                        },
                    },
                },
            },
            MuiBreadcrumbs: {
                styleOverrides: {
                    li: {
                        //color: darken('#eee', 0.1)
                    },
                    root: {
                        marginTop: '8px'
                    }
                }
            },
            MuiPaper: {
                styleOverrides: {
                    root: {
                        backgroundColor: '#fff2'
                    }
                }
            },
            MuiSvgIcon: {
                styleOverrides: {
                    // Target the root class of the SvgIcon
                    root: {
                        color: '#fff', // e.g., '#007bff'
                    },
                },
            },
            MuiMenu: {
                styleOverrides: {
                    paper: {
                        backgroundColor: lighten('#252423ff', 0.25)
                    }
                }
            }
        }
    }
})

export type MuiCustomComponents = Components<Omit<Theme, 'components'>> & MuiDropdownComponent;